
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-category/[id]",
      function () {
        return require("private-next-pages/store-category/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store-category/[id]"])
      });
    }
  